import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var additionalImageSchema = {
    image_url: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
            noClose: true
        }),
        elementType: 'image',
        label: 'Допълнителна картинка',
        value: null,
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидна допълнителна картинка',
    }),
};
export default additionalImageSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/additionalImageSchema.ts
// module id = 252
// module chunks = 0